(function (app) {

    app.config([
        "$stateProvider", function($stateProvider) {
            $stateProvider.state("Home.Settings",
                {
                    url: "/Settings",
                    component: "settings",
                    resolve: {
                        user: ["currentUser", function (currentUser) {
                            return currentUser;
                        }]
                    },
                    redirectTo: "Home.Settings.CRMSetup"
                });
        }
    ]);

    app.component("settings",
        {
            templateUrl: "/App/Settings/settings-template.html",
            controller: settingsController,
            bindings: {
                user: "<"
            }
        });

    settingsController.$inject = [];
    function settingsController() {}

})(window.app); // jshint ignore:line